import React from "react";
import { FiX } from "react-icons/fi";
import "../styles/App.css";
import "../styles/InternshipInfoCard.css";

export default function InternshipInfoCard({ onClose }) {
  return (
    <div className="internship-card">
      <button
        type="button"
        className="internship-card-close"
        onClick={onClose}
        aria-label="Dismiss announcement"
      >
        <FiX />
      </button>

      <div className="internship-card-pill">
        🌙✨ Internship Program Announcement ✨🌙
      </div>

      <h2 className="internship-card-title">
        🕌 Dawat-e-Islami India – 6-Month Internship Program
      </h2>

      <p className="internship-card-text">
        Dawat-e-Islami India’s IT Department is launching this 6-month
        Internship Program starting from January 1, 2026 — exclusively for male
        students.
      </p>

      <p className="internship-card-text">
        Here’s your golden opportunity to boost your skills under the mentorship
        of skilled professionals, all within a professional and Islamic
        environment.
      </p>

      <p className="internship-card-text">
        If you are a true Aashiq-e-Rasool ﷺ , Aashiq-e-Aala Hazrat and currently
        pursuing or have completed BE/B.Tech, BSc, BCA, CS/IT, or an equivalent
        degree — this program is made for you!
      </p>

      <p className="internship-card-text">So don’t wait — Fill this form.</p>

      <div className="internship-card-subtitle">
        ⭐ To increase your chances of getting shortlisted:
      </div>

      <ul className="internship-card-list">
        <li><span className="emoji-bullet"></span> Basic knowledge of JavaScript, Python, or PHP</li>
        <li><span className="emoji-bullet"></span> Familiarity with HTML, CSS & Git</li>
      </ul>

      <p className="internship-card-text">
        The program will be conducted in Pune, Maharashtra, offering a chance to
        contribute to real Islamic IT projects serving the Ummah.
      </p>

      <p className="internship-card-text">
        Start your journey today — a journey that benefits you in this world and
        the Hereafter. 🌙✨
      </p>
    </div>
  );
}